import { computed, reactive, ref } from 'vue'
import { ElMessage } from '@park-ui/components/message'

export function useCigSelect(ctx: any, props: any, t: any, states: any) {
  const customVal = ref({
    custom: '',
  })
  const customRule: any = {
    custom: [
      {
        required: true,
        message: t('el.form.placeholder.input'),
        trigger: 'blur',
      },
    ],
  }
  const editOption = ref(false)
  const delOption = ref(false)
  const createdOption = reactive({
    leftContent: '',
    rightContent: '',
  })
  // 表单ref
  const selectForm = ref()
  // options is no data
  const optionSize = computed(() => states.options.size)
  function createOption() {
    customVal.value.custom = ''
    if (delOption.value) delOption.value = false
    if (props.customContent) {
      return ctx.emit('create-options')
    }
    if (!editOption.value) editOption.value = true
  }
  function deleteOption() {
    if (optionSize.value === 0) {
      return ElMessage({
        message: t('el.select.noData'),
        type: 'warning',
      })
    }
    if (!delOption.value) delOption.value = true
    if (editOption.value) editOption.value = false
  }
  // delete
  function onSelectOptionDelete(vm: any, byClick: boolean) {
    // 是否选中
    const isCheck = props.multiple
      ? props.modelValue.includes(vm.value)
      : vm.value === props.modelValue
    // 触发emit
    realSelectionDelete(isCheck, vm, byClick)
  }
  function realSelectionDelete(isCheck: boolean, vm: any, byClick: boolean) {
    ctx.emit('delete-options', vm.value, isCheck, byClick)
  }
  function onConfirm() {
    selectForm.value.validate((isValid: boolean) => {
      if (isValid) {
        ctx.emit('create-options', customVal.value.custom)
        editOption.value = false
      }
    })
  }
  function onCancel() {
    customVal.value.custom = '' // 清空输入
    editOption.value = false // 隐藏输入框
  }

  return {
    customVal,
    customRule,
    editOption,
    delOption,
    createdOption,
    selectForm,
    createOption,
    deleteOption,
    onSelectOptionDelete,
    onConfirm,
    onCancel,
  }
}
